export default __webpack_public_path__ + "static/media/youtube-channel.3a2c64c2.svg";